import(/* webpackMode: "eager" */ "D:\\portal\\fsms-fe\\src\\app\\(ptl)\\loading.tsx");
